module.exports = __webpack_public_path__ + "img/config.bc4ebc23.svg";